import type { FamilyLinks } from "../../../model/family-links.ts";
import { USE_CASE_PAGES } from "./use-case-pages.ts";
import { USE_CASES_WORDS_EN as EN } from "./use-cases-words-en.ts";
import { USE_CASES_WORDS_ES as ES } from "./use-cases-words-es.ts";

// The use-cases family's pages, for the footer and other pages' bodies: one entry per page, its
// label from the page's two words files.
export const USE_CASE_LINKS: FamilyLinks = {
  title: { en: EN.footerTitle, es: ES.footerTitle },
  links: USE_CASE_PAGES.map((page) => ({
    label: { en: page.words.en.linkLabel, es: page.words.es.linkLabel },
    href: page.path,
  })),
};
